import gql from 'graphql-tag'

export default gql`
query searchLabels($_id: String!) {
  labels(
    filter: {
      _id: $_id
    }
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchLabels.js